<template>
  <el-dialog title="新增参展商品" :visible.sync="visible" class="dialog">
    <el-form
      :inline="true"
      :model="filters" ref="filters"
      style="display:flex;height:36px;margin-top: -20px;margin-bottom: 6px">
      <el-form-item style="width:100%;display:flex" label="商品名称：">
        <el-input v-model="filters.goodsName" placeholder="请输入商品名称/型号/标语" maxlength="20"/>
      </el-form-item>
      <el-form-item style="display:flex;width:100%;" label="品类：">
        <el-select filterable v-model="filters.brandTypeId" placeholder="请选择" @change="getbrandarr">
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in brandTypearr"
            :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item style="width:100%;display:flex;" label="品牌：">
        <el-select filterable v-model="filters.brandId" placeholder="请选择">
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in brandarr"
            :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item style="display:flex;margin-right:0;">
        <el-button type="danger" @click="onSubmit()">查 询</el-button>
      </el-form-item>
    </el-form>
    <div>
      <!-- 查询参展商品列表 -->
      <el-table :data="goods" :row-key="getRowKeys" class="ban_tab" stripe border :header-cell-style="{background:'#bbbbbb'}"
        @selection-change="handleSelectionChange"
        style="height:auto;margin-top:10px">
        <el-table-column type="selection" :reserve-selection="true" align="center"/>
        <el-table-column prop="GoodModelCode" label="产品型号" align="center">
          <template scope="scope">
            <span
              :title="scope.row.GoodModelCode"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
              {{scope.row.GoodModelCode}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="名称" align="center">
          <template scope="scope">
            <span
              :title="scope.row.Title"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
              {{scope.row.Title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="GoodsTypeName" label="品类" align="center">
          <template scope="scope">
            <span
              :title="scope.row.GoodsTypeName"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
              {{scope.row.GoodsTypeName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="BrandName" label="品牌" align="center">
          <template scope="scope">
            <span
              :title="scope.row.BrandName"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
              {{scope.row.BrandName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="BbName" label="所属品牌商" align="center">
          <template scope="scope">
            <span
              :title="scope.row.BbName"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
              {{scope.row.BbName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop='check' label="是否秒杀商品" width="270px" fixed="right" align="center">
          <template slot-scope="scope" class="tempSpan">
            <el-checkbox :value="getCheck(scope.row.Id)" :reserve-selection="true" @change="setCheck(scope.row.Id)"/>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" style="padding: 10px 0">
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="total"
          :current-page="pageIndex"
          style="float:right;"/>
      </el-col>
    </div>
    <div slot="footer" style="text-align: center;">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="danger" @click="dataFormSubmit()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SelectBrandTypeBaseDataByCondition } from '../../api/newOss';
import { SelectGoodsByCityId, AddGoods, SelectGoodsBrandByBrandType } from "../../api/api";
  export default {
    name: "addCommodity",
    props: ["guid", "cityId"],
    data () {
      return {
        visible: false,
        addVisible: false,
        ids: '',
        goods:[], // 列表list
        selectGoods:[],
        goodIdarr:[],
        brandTypearr: [],
        brandarr: [],
        checkList: [], // 是否秒杀列表
        filters: {
          goodsName: "",
          brandTypeId: 0,
          brandId: 0
        },
        pageIndex: 1, // 页码
        pageSize: 10, // 	每页行数
        total: 1,
        page: 1
      }
    },
    methods: {
      getRowKeys (row) {
          return row.Id; // id为列表数据的唯一标识
      },
      // 设置
      setCheck (id) {
        console.log(id,'set+++');
        var index = this.checkList.indexOf(id)
        if (index >= 0) {
          this.checkList.splice(index, 1);
        } else {
          this.checkList.push(id);
        }
      },
      // 获取
      getCheck (id) {
        console.log(id,'get');
        var index = this.checkList.indexOf(id)
        if (index >= 0) {
          return true
        } else {
          return false
        }
      },
      // 初始化数据
      init () {
        this.visible = true
        this.filters = {
          goodsName: "",
          brandTypeId: 0,
          brandId: 0
        }
        this.$nextTick(() => {
          // this.$refs['filters'].resetFields()
          this.getgoodlist()
        })
      },
      // 初始化列表数据
      getgoodlist(){
        var obj = {
            cityId:this.cityId,
            guid: this.guid,
            key: this.filters.goodsName,
            goodsTypeId: this.filters.brandTypeId,
            brandId: this.filters.brandId,
            pageIndex:this.pageIndex, // 页码
            pageSize:10
        }
        // 查询参展商品列表
        SelectGoodsByCityId(obj).then(data=>{
          if(data.ResultCode == 1){
              this.goods = data.ResultObj
              // for (var item of this.goods) {
              //   // item.check = false // 增加秒杀选框
              //   this.$set(item, 'check', false)
              // }
              this.total = data.RowsCount;
          }else{
            this.goods = [];
            this.total = 0
          }
        })
      },
      // 确认
      dataFormSubmit () {
        if(this.goodIdarr.length == 0){
        this.$swal({
            text:"请选择参展商品",
            type:"warning"
        })
        return false
        }
        var goods = ''
        for (var index of this.goodIdarr){
          var ischeck = this.checkList.indexOf(index); // 商品是否被选中秒杀
          // var good = this.goods.find((item)=>{return item.Id == index})
          // this.selectGoods.push(good)
          var check = ischeck >= 0 ? '1' : '0'
          goods = goods + index + '|' + check + ','
        }
        goods = goods.slice(0, goods.length-1)
        var obj = {
          guid: this.guid,
          goods: goods
        }
        AddGoods(obj).then(data=>{
          if(data.ResultCode == 1){
              this.getgoodlist()
              this.visible = false
              this.$emit('refreshDataList', this.selectGoods)
              // this.$refs['filters'].resetFields()
          }
        })
      },
      //查询
      onSubmit() {
        this.pageIndex = 1;
        this.getgoodlist();
      },
      //分页
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getgoodlist()
      },
      // 复选框
      handleSelectionChange(val) {
         this.goodIdarr = [];
          val.forEach(element => {
          this.goodIdarr.push(element.Id);
        });
      },
      //获取品类
      getBrandType() {
        var obj = {
          userId: localStorage.Id
        };
        SelectBrandTypeBaseDataByCondition(obj).then(data => {
          if (data.ResultCode == 1) {
            this.getbrandarr();
            this.brandTypearr = data.ResultObj;
            this.newpinleioptions = data.ResultObj;
            this.brandTypearr.unshift({
              Id: 0,
              Name: "全部"
            });
          }
        });
      },
      //获取品牌
      getbrandarr() {
        this.filters.brandId = 0;
        var obj = {
          userId: localStorage.Id,
          brandTypeId: this.filters.brandTypeId
        };
        SelectGoodsBrandByBrandType(obj).then(data => {
          if (data.ResultCode == 1) {
            this.brandarr = data.ResultObj;
            this.brandarr.unshift({
              Id: 0,
              Name: "全部"
            });
          }
        });
      }
    },
    mounted() {
      this.getgoodlist();
      this.getBrandType();
    }
  }
</script>
<style scoped lang="less">
  .dialog {
    width: 120% !important;
    border-radius: 5px !important;
    margin-left: -11% !important;
  }
</style>


// WEBPACK FOOTER //
// addExhibitorsCategory.vue?2df9286d